import type * as api from '@gitbook/api-client';
import { DialogGradientAside, useScreenType } from '@gitbook/spine-react';

import { IntegrationTileIcon } from './IntegrationTileIcon';

/**
 * Colorful branded aside for an integration dialog, showing the integration icon.
 */
export function IntegrationDialogAside(props: {
    integration?: api.Integration;
    backgroundSrc?: {
        light: string;
        dark: string;
    };
}) {
    const { integration, backgroundSrc } = props;
    const { isMobile } = useScreenType();

    return (
        <DialogGradientAside
            backgroundSrc={backgroundSrc}
            className="justify-end p-5 md:min-h-full md:w-72 lg:w-72"
        >
            {integration ? (
                <div className="flex flex-1 flex-col items-start justify-start gap-6 p-3">
                    <IntegrationTileIcon size={isMobile ? 48 : 72} integration={integration} />
                    <div className="flex flex-col gap-3">
                        <h2 className="text-ui-heading-medium text-base">{integration.title}</h2>
                        <p className="text-ui-base text-secondary">{integration.description}</p>
                    </div>
                </div>
            ) : null}
        </DialogGradientAside>
    );
}
